import { LOGO_URL } from "@/lib/langs";

export const AuroraLogo = ({ size = 40, pulse = true, rings = false, testId = "aurora-logo" }) => (
  <div className="relative shrink-0" style={{ width: size, height: size }} data-testid={testId}>
    {rings && (
      <>
        <span className="hud-ring-spin absolute -inset-[18%] rounded-full border border-dashed border-cyan-400/40" />
        <span className="hud-ring-spin-rev absolute -inset-[34%] rounded-full border border-cyan-400/25" style={{ borderTopColor: "var(--au-violet)" }} />
      </>
    )}
    <div className={`relative h-full w-full overflow-hidden rounded-[24%] ${pulse ? "arc-pulse" : ""}`}>
      <img src={LOGO_URL} alt="SpeechFlow" className="h-full w-full object-cover" draggable={false} />
      <span className="pointer-events-none absolute inset-0 rounded-[24%] ring-1 ring-inset ring-white/15" />
    </div>
  </div>
);

export const AuroraWordmark = ({ className = "" }) => (
  <span className={`font-display font-extrabold tracking-tight text-foreground aurora-glow ${className}`} data-testid="aurora-wordmark">
    SPEECH<span className="text-[color:var(--au-green)]">FLOW</span>
  </span>
);
